export const LOGIN = 'LOGIN'; // Costante per indicare il nome della action in REDUX nel reducer e nella App
export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';